
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/servicos/pecas",
      function () {
        return require("private-next-pages/servicos/pecas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/servicos/pecas"])
      });
    }
  